module.exports = __webpack_public_path__ + "static/media/5-points.3714321b.png";